import { authCookies } from "@/services/cookies";
import { Repo } from "@/store/admin/repo";

export default function isParent({ next }) {
  const user = authCookies.getUser() || {};
  if (user.portal !== "parent") {
    return next({ name: "Dashboard" });
  }
  if (Object.keys(user).length) {
    Repo.user = user;
  }
  return next();
}
